import { render, staticRenderFns } from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=template&id=d839afa2&scoped=true&"
import script from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=script&lang=ts&"
export * from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDetailTabsAdditionalOptions.vue?vue&type=style&index=0&id=d839afa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d839afa2",
  null
  
)

export default component.exports